import Image from 'next/image'
import React from 'react'
import thank from '@/public/images/check-circle.svg'

function ThankYou({thankYou}) {
    return (

        <div className='bg-primaryBlue rounded-3xl flex flex-col items-center justify-center h-96 mt-10 custom-container'>
            <Image src={thank} alt='thankyou check circle' width={32} height={32} className='mx-auto'/>
            <p className='p-text text-primaryWhite mt-3'>{thankYou.detials}</p>
            <h1 className='header-sub text-primaryWhite mt-5'>{thankYou.contact}</h1>
        </div>
    )
}

export default ThankYou